import { makeStyles } from 'tss-react/mui';

export default makeStyles()({
    drawer: {
        '& .MuiDrawer-paper': {
            scrollbarWidth: 'none',
            '&::-webkit-scrollbar': {
                display: 'none'
            }
        }
    }
});
